/** Shared background-music provider options (must match backend narration_background_music.py). */

export const BG_MUSIC_PROVIDER_OPTIONS = [
  { value: 'none', label: 'Off — no background music' },
  {
    value: 'auto',
    label: 'Auto (Lyria → MiniMax → Hailuo → Runway)',
  },
  {
    value: 'lyria',
    label: 'Lyria (Gemini / Vertex)',
  },
  {
    value: 'minimax',
    label: 'MiniMax Music API',
  },
  {
    value: 'hailuo',
    label: 'Hailuo / MiniMax account key',
  },
  {
    value: 'runway',
    label: 'Runway instrumental (looping ambient)',
  },
];

/** Options for editor regenerate dialog (no "off"). */
export const BG_MUSIC_GENERATION_OPTIONS = BG_MUSIC_PROVIDER_OPTIONS.filter((p) => p.value !== 'none');

export const BG_MUSIC_PROVIDER_LABELS = Object.fromEntries(
  BG_MUSIC_PROVIDER_OPTIONS.map((p) => [p.value, p.label]),
);

export const DEFAULT_BG_MUSIC_PROVIDER = 'auto';
